import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';
import { JiraServiceManagementIcon, JiraServiceManagementLogo } from '@atlaskit/logo';
import { AvatarMenuV2 } from '@atlassian/help-center-avatar-menu';

interface HeaderProps {
    fetchUser: () => void;
}

const Home = () => (
    <ProductHome
        icon={JiraServiceManagementIcon}
        logo={JiraServiceManagementLogo}
        href={`${window.location.origin}/jira/your-work`}
    />
);

const Header: React.FC<HeaderProps> = ({ fetchUser }: HeaderProps) => {
    di(AvatarMenuV2);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return <AtlassianNavigation label="site" renderProductHome={Home} renderProfile={AvatarMenuV2} primaryItems={[]} />;
};

export default withAnalyticsContext({ component: 'Header' })(Header);
